import { useEffect } from 'react';

import { useSelector } from 'react-redux';
import { map } from '../core/MapView';
import { usePrevious } from '../../reactHelper';

const MapSelectedDevice = () => {
  const selectedDeviceId = useSelector((state) => state.devices.selectedId);
  const previousDeviceId = usePrevious(selectedDeviceId);

  const position = useSelector((state) => state.session.positions[selectedDeviceId]);

  useEffect(() => {
    if ((selectedDeviceId !== previousDeviceId) && position) {
      const canvas = map.getCanvas();
      map.easeTo({
        center: [position.longitude, position.latitude],
        zoom: Math.max(map.getZoom(), 15),
        offset: [-canvas.width * 0.10, 0],
        duration: 0,
      });
    }
  });

  return null;
};

export default MapSelectedDevice;
